import React, { useState, useEffect, useContext } from "react"
import "../AddNewLineage.css"
import axios from "axios"
import { MARTBUILDER_API } from "../../../constants/serverConfig"
import { AuthContext } from "../../../AuthContext"
import { useMsal } from "@azure/msal-react"
import { protectedResources } from "../../../msalConfig"
import { IoIosInformationCircle } from "react-icons/io"
import OnClickPopUp from "../../../utils/ReUsableComponents/OnClickPopUp"

const APIEndpoint = ({
  connectionData,
  onSubmitFun,
  // testConnectionSuccess,
  // submissionSuccess,
}) => {
  const { instance } = useMsal()
  const { dcerror, dctoken, getDatacraftToken } = useContext(AuthContext)
  const account = instance.getActiveAccount()
  const request = {
    scopes: protectedResources.datacraft.scopes,
    account: account,
  }

  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const [connectionCreds, setConnectionCreds] = useState({
    product: { id: "" },
    hostname: "",
    portName: "",
    userName: "",
    token: "",
    database: "",
  })
  const [productTableData, setProductTableData] = useState([])

  const [subAPILineage, setSubAPILineage] = useState("ApacheSpark")
  const [producerSetup, setProducerSetup] = useState(null)

  const handleAPILineageSelect = (lineage) => {
    setSubAPILineage(lineage)
  }

  const handleRadioChange = (e) => {
    setProducerSetup(e.target.value)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setConnectionCreds((prevCreds) => ({
      ...prevCreds,
      [name]: value,
    }))
  }

  // const handleSubmit = (isTestConnection) => {
  //   const formData = {
  //     ...connectionData,
  //     connectionCreds,
  //   }
  //   if (onSubmitFun) {
  //     onSubmitFun(formData, isTestConnection)
  //   }
  // }

  const fetchProductTableData = async (dctoken) => {
    console.log(dctoken, "<==dctoken")
    const ourRequest = axios.CancelToken.source()
    try {
      let response = await axios.get(`${MARTBUILDER_API}/product`, {
        headers: {
          Authorization: `Bearer ${dctoken}`,
          "Content-Type": "application/json",
        },
        CancelToken: ourRequest.token,
      })
      setProductTableData(response?.data)
      console.log(response, "<==response")
    } catch (err) {
      if (axios.isCancel(err)) {
        return
      } else {
        console.error(err)
      }
    }
    return () => {
      ourRequest.cancel()
    }
  }

  const callapiwithtoken = async (callback) => {
    ; (async () => await getDatacraftToken())()
    if (dctoken) {
      await callback(dctoken)
    }
    if (dcerror) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken
        await callback(rtoken)
      } catch (error) {
        console.log(error)
      }
    }
  }

  useEffect(() => {
    callapiwithtoken(fetchProductTableData)
  }, [dctoken, dcerror])

  return (
    <div>
      <div
        className="individualLRow"
        style={{ borderBottom: "1px solid #d3d3d3", padding: "30px" }}
      >
        <div>
          <label htmlFor="resourceType" id="sub-heading" className="ANLLabel">
            Compute Type
          </label>
          <br />
          <br />
          {/* <div className="inputHostName">
          <label htmlFor="hostName">Host Name</label>
          <br />
          <input
            type="text"
            id="hostName"
            name="hostName"
            placeholder="Enter Host Name"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="portName">Port Name</label>
          <br />
          <input
            type="text"
            id="portName"
            name="portName"
            placeholder="Enter Port Name"
            onChange={handleChange}
          />
        </div> */}
          <div className="imageWrapper">
            <>
              <div
                className={`lineageIconsImage ${subAPILineage === "ApacheSpark" ? "selectedImage" : ""
                  }`}
                style={
                  subAPILineage === "ApacheSpark"
                    ? { width: "125px", padding: "1rem", color: "#000000" }
                    : {
                      border: "1px solid rgb(234, 234, 234)",
                      backgroundColor: "white",
                      width: "125px",
                      padding: "1rem",
                      color: "#000000",
                    }
                }
                onClick={() => handleAPILineageSelect("ApacheSpark")}
              >
                <span style={{ textAlign: "center", fontWeight: "600" }}>
                  Apache Spark
                </span>
              </div>
            </>
            <>
              <div
                className={`lineageIconsImage ${subAPILineage === "AirFlow" ? "selectedImage" : ""
                  }`}
                style={
                  subAPILineage === "AirFlow"
                    ? { width: "125px", padding: "1rem", color: "#000000" }
                    : {
                      border: "1px solid rgb(234, 234, 234)",
                      backgroundColor: "white",
                      width: "125px",
                      padding: "1rem",
                      color: "#000000",
                    }
                }
                onClick={() => handleAPILineageSelect("AirFlow")}
              >
                <span style={{ textAlign: "center", fontWeight: "600" }}>
                  Air Flow
                </span>
              </div>
            </>
            <>
              <div
                className={`lineageIconsImage ${subAPILineage === "DBT" ? "selectedImage" : ""
                  }`}
                style={
                  subAPILineage === "DBT"
                    ? { width: "125px", padding: "1rem", color: "#000000" }
                    : {
                      border: "1px solid rgb(234, 234, 234)",
                      backgroundColor: "white",
                      width: "125px",
                      padding: "1rem",
                      color: "#000000",
                    }
                }
                onClick={() => handleAPILineageSelect("DBT")}
              >
                <span style={{ textAlign: "center", fontWeight: "600" }}>
                  DBT
                </span>
              </div>
            </>
          </div>
        </div>
      </div>
      <div className="individualLRow">
        <div>
          <label htmlFor="product">Products Name</label>
          <br />
          <select
            id="product"
            name="product"
            onChange={handleChange}
            value={connectionCreds.product.id}
            style={{ fontSize: "12px" }}
          >
            {productTableData?.map((product, index) => (
              <option key={index} value={product?.id}>
                {product?.name}
              </option>
            ))}
          </select>
          <p>
            Do not have a product registered?{" "}
            <span style={{ color: "#0a69b4", cursor: "pointer" }}>
              Register Now
            </span>
          </p>
        </div>
      </div>

      <div
        className="individualLRow "
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: "3px",
          paddingBottom: "0px",//required for overriding other style
        }}
      >
        <label>
          Have you completed the necessary steps for setting up the Producer?
        </label>

        <div>
          <IoIosInformationCircle
            style={{
              color: "#0a69b4",
              fontSize: "20px",
              marginLeft: "15px",
              cursor: "pointer",
            }}
            onClick={handlePopoverOpen}
          />

          <OnClickPopUp
            open={open}
            anchorEl={anchorEl}
            handlePopoverClose={handlePopoverClose}
          />
        </div>
      </div>

      <div
        style={{
          border: "0px solid red",
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "center",
          paddingLeft: "35px",
        }}
      >
        <span>Yes</span>
        <input
          type="radio"
          name="producerSetup"
          value="yes"
          checked={producerSetup === "yes"}
          onChange={handleRadioChange}
          style={{ minWidth: "0px", margin: "0px 20px" }}
        />

        <span>No</span>
        <input
          type="radio"
          name="producerSetup"
          value="no"
          checked={producerSetup === "no"}
          onChange={handleRadioChange}
          style={{ minWidth: "0px", margin: "0px 20px" }}
        />
      </div>

      <div
        className="individualLRow"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          padding: "0px 30px",
          margin: " 10px 0px",
        }}
      >
        <label>Kafka Details Fetched</label>
      </div>

      <div
        style={{
          border: "0px solid red",
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "center",
          paddingLeft: "25px",
        }}
      >
        <div>
          <div className="details-box">
            <p>Topic: msk.databookopenlineageprod.lns.topic.internal.any.v1</p>
            <p>Username: prod.databook-openlineageprod-lns.v1</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default APIEndpoint
